// Get doc data and merge doc.id
const getDocData = doc => (doc.exists() ? { id: doc.id, ...doc.data() } : null);

export default getDocData;
